import { Autocomplete, FormControl, FormHelperText, TextField } from "@mui/material";
import type { FC } from "react";
import type { UsableAccountPersonField } from "../../../server/supabase-segment-field-service";
import type { UseMakeSortedSegmentFields } from "../hooks/use-sorted-segment-fields";
import type { Condition } from "../../../types/segment-schema";

export const ConditionField: FC<{
  segmentFields: ReturnType<UseMakeSortedSegmentFields>["fields"];

  groupingFn: ReturnType<UseMakeSortedSegmentFields>["groupingFn"];
  condition: Condition;
  handleFieldChange: (value: Partial<Condition>) => void;
  disabled?: boolean;
  errMsg?: string;
}> = ({ segmentFields, groupingFn, condition, handleFieldChange, disabled, errMsg }) => {
  return (
    <FormControl sx={{ mr: 1 }} fullWidth error={Boolean(errMsg)}>
      <Autocomplete
        disablePortal={false}
        fullWidth
        size="small"
        options={segmentFields}
        getOptionLabel={(option) => option.display_name}
        getOptionDisabled={(option) => option.disabled}
        groupBy={groupingFn}
        onChange={(_, value) => {
          if (!value) return;

          handleFieldChange({
            field: value.key,
            ...makeDefaultConditionForFieldType(value.field_type),
          });
        }}
        value={segmentFields.find((f) => f.key === condition.field) ?? segmentFields[0]}
        disabled={disabled}
        renderInput={(params) => <TextField {...params} label="Field" variant="outlined" />}
      />
      {Boolean(errMsg) && <FormHelperText>{errMsg}</FormHelperText>}
    </FormControl>
  );
};

function makeDefaultConditionForFieldType(
  fieldType: UsableAccountPersonField["field_type"],
): Omit<Condition, "field"> {
  switch (fieldType) {
    case "BOOLEAN":
      return {
        operation: "IS",
        invert: false,
        values: ["true"],
      };
    case "DATE":
      return {
        operation: "ON",
        invert: false,
        values: [],
      };
    case "MONTH_DAY":
      return {
        operation: "ON",
        invert: false,
        values: ["(1,1)"],
      };
    case "TEXT":
    case "COUNTRY":
    case "ADDRESS":
    case undefined:
    case null:
      return {
        operation: "IS",
        invert: false,
        values: [],
      };
  }
}
